import {
  NATIVE_DATA_FETCH_NATIVE_SERVICES_STATUS_SUCCESS,
  NATIVE_DATA_FETCH_NOTIFICATION_SUCCESS,
  NATIVE_DATA_HIDE_NOTIFICATION_SUCCESS,
  NATIVE_DATA_SET_QR_CODE_SCAN_SUCCESS,
  NATIVE_DATA_SET_SERVICES_STATUS_SUCCESS,
  NATIVE_DATA_SET_TEMP_ID
} from '../../types/nativeData';

const INITIAL_STATE = {
  notification: undefined,
  servicesStatus: {},
  tempId: undefined,
  successQrCodeScanCounter: 0
};

const setServicesStatusSuccess = (state, { servicesStatus = {} }) => {
  return {
    ...state,
    ...servicesStatus
  };
};

const nativeBridgeReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case NATIVE_DATA_FETCH_NOTIFICATION_SUCCESS:
      return (() => {
        const {
          notification: { title, content, status }
        } = action;
        return {
          ...state,
          notification: {
            title,
            content,
            status
          }
        };
      })();
    case NATIVE_DATA_HIDE_NOTIFICATION_SUCCESS:
      return {
        ...state,
        notification: undefined
      };
    case NATIVE_DATA_SET_SERVICES_STATUS_SUCCESS:
      return setServicesStatusSuccess(state, action);
    case NATIVE_DATA_FETCH_NATIVE_SERVICES_STATUS_SUCCESS:
      return setServicesStatusSuccess(state, action);
    case NATIVE_DATA_SET_TEMP_ID:
      return (() => {
        const { tempId } = action;
        return {
          ...state,
          tempId
        };
      })();
    case NATIVE_DATA_SET_QR_CODE_SCAN_SUCCESS:
      return (() => {
        const { successQrCodeScanCounter = 0 } = state;
        return {
          ...state,
          successQrCodeScanCounter: successQrCodeScanCounter + 1
        };
      })();
    default:
      return state;
  }
};

export default nativeBridgeReducer;
